<template>
  <div class="row">
    <div class="col p-3 p-md-4">
      <div class="col text-center">
        <h2 class="h4 mt-3 mb-5">
          {{ text }}
        </h2>
      </div>

      <div class="col d-flex flex-row justify-content-center decline__container">
        <b-button size="sm" variant="primary" @click.prevent.stop="cancel">
          {{ $t('Cancel') }}
        </b-button>
        <b-button size="sm" variant="outline-primary" @click.prevent.stop="confirm">
          Yes
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Confirm",
  props: ['text'],
  methods: {
    confirm: function() {
      this.$emit('confirmation', true);
    },
    cancel: function () {
      this.$emit('confirmation', false);
    }
  }
}
</script>

<style scoped lang="scss">
.decline__container button {
  flex: 0 1 30%;
  margin: 0 10px;
  min-width: 90px;
}
</style>
